/* eslint-disable eqeqeq */
// Вкладка «Чаты» нижнего меню: значок с числом непрочитанных сообщений.
// Неактивная вкладка бледнеет как остальные, но красный счётчик остаётся ярким.
import { Link } from "react-router-dom";
import React from 'react';

function ChatsMenuItem(props) {
    const isSelected = window.location.pathname.includes(props.link)
    const count = props.unread > 0 ? props.unread : 0
    const faded = isSelected ? undefined : { opacity: 0.4 }
    const handleOnClick = () => {
        props.setCurrentLink(props.link)
    }
    return (
        <Link to={props.link} aria-label={count > 0 ? props.title + ': непрочитанных ' + count : props.title}>
            <div onClick={handleOnClick} className={isSelected ? "bottom_menu_item bottom_menu_item--selected hover" : "bottom_menu_item hover"}>
                <div className="left_item_icon">
                    <div style={{height : '20px', width : '20px'}} className="relative">
                        <img alt='' style={faded} className={"bottom_menu_icon"} src={props.icon}/>
                        {count > 0 && <span className="menu_chats_badge">{count > 99 ? '99+' : count}</span>}
                    </div>
                </div>
                <p style={faded} className="bottom_menu_title">{props.title}</p>
            </div>
        </Link>
    );
}

export default ChatsMenuItem;
